// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateMachineTypeMutation($input: UpdateMachineTypeInput!) {
    updateMachineType(input: $input) {
      machineTypeEdge {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
